@if (isTransferInHasSubstitute()) {
  <div class="table-alert__toggle" id="divShowItem{{item?.transferId}}" (click)="showSubstituted($event)">
  </div>
}
<div id="divItemDetails{{item?.transferId}}" class="table-alert has-multiple-alerts myn3" (click)="showSubstituted($event)"
  [ngClass]="{'is-open':item?.showSubstitutedItem}">
  <div class="flex-auto pr2 table-alert__body">
    <div class="flex align-center">
      <div class="mr2">
        <svg>
          <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
        </svg>
      </div>
      <div class="flex-auto">
        <div class="bold mb1">Transferred in place of</div>
        <table class="table has-xs-rows bg-gray-97 border-radius">
          <tbody>
            <tr>
              <td class="table--fill-remaining-width height-4">
                <div class="drug-name--primary truncate">
                  <div id="divDisplayName">{{item.substitutedItemDetail?.displayName}}</div>
                </div>
                <div class="drug-name--alternate truncate--single">
                  <div class="flex h6">
                    <span class="bold mr1">NDC</span>
                    <span id="divUnitNdc">{{item.substitutedItemDetail?.unitNdc}}</span>
                    <span class="bold ml2 mr1">Item #</span>
                    <span id="divItemId">{{item.substitutedItemDetail?.itemId}}</span>
                    @if (displayCode) {
                      <div>
                        <span id="lblTransferSubstituteJcode" class="bold ml2 mr1">J-Code</span>
                        <span id="divTransferSubstituteJcode">{{displayCode}}</span>
                      </div>
                    }
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="table-alert__close" (click)="showSubstituted($event)">
    <svg>
      <use xlink:href="./assets/icons/connect-icons.svg#Delete"></use>
    </svg>
  </div>
</div>